import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {LogisticsVehicleLinkComponent} from "./components/logistics-vehicle-link/logistics-vehicle-link.component";


@NgModule({
  declarations: [
    LogisticsVehicleLinkComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  exports: [
    LogisticsVehicleLinkComponent
  ],
  providers: [

  ]
})

export class LogisticsVehicleModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapLogisticsVehicleModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(LogisticsVehicleModule);
};

export const downgradedLogisticsVehicleModule = downgradeModule(bootstrapLogisticsVehicleModule);
